import React, { useState, lazy } from 'react';
import { ShoppingCartIcon } from 'lucide-react';
import { ExtraBonusModal } from './ExtraBonusModal';
export function BundleShowcase() {
  const [isExtraBonusModalOpen, setIsExtraBonusModalOpen] = useState(false);
  const images = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/32SqiMYA8hJAQwFwVwt7Ch/ChatGPT_Image_3_nov_2025%2C_10_26_32_p.m..png',
    alt: 'Mamá leyendo 50 Recetas de 15 Minutos'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/38k37WKe7ecxCSgdPLC3kd/oferta_-1.png',
    alt: 'Bundle Sistema 15/15'
  }];
  return <>
      <section className="py-8 sm:py-12 md:py-16 bg-white" data-id="element-45">
        <div className="max-w-6xl mx-auto px-4" data-id="element-46">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12" data-id="element-47">
            Todo en un Solo Paquete
          </h2>
          {/* Grid de imágenes - Visible en todos los dispositivos */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-48">
            {images.map((image, index) => <div key={index} className="rounded-lg sm:rounded-xl overflow-hidden shadow-xl" data-id="element-49"></div>)}
          </div>
          <div className="text-center mt-6 sm:mt-8" data-id="element-50">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 sm:p-6 md:p-8 rounded-xl sm:rounded-2xl border-2 border-orange-200 shadow-lg" data-id="element-51">
              <div className="inline-flex items-center gap-2 bg-orange-600 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-full mb-3 sm:mb-4 shadow-md" data-id="element-52">
                <span className="text-xl sm:text-2xl" data-id="element-53">📦</span>
                <span className="text-base sm:text-lg md:text-xl font-bold" data-id="element-54">
                  Paquete Completo
                </span>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-55">
                Todo en un Solo Lugar
              </h3>
              <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-4 sm:mb-6 leading-relaxed px-4" data-id="element-56">
                Acceso inmediato a todo el sistema + bonos exclusivos
              </p>
              <div className="grid sm:grid-cols-3 gap-3 sm:gap-4 mt-4 sm:mt-6" data-id="element-57">
                <div className="bg-white p-3 sm:p-4 rounded-lg shadow-md" data-id="element-58">
                  <div className="text-2xl sm:text-3xl mb-2" data-id="element-59">📖</div>
                  <div className="font-semibold text-sm sm:text-base text-gray-800" data-id="element-60">
                    50 Recetas Express
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600" data-id="element-61">
                    Cronometradas y probadas
                  </div>
                </div>
                <div className="bg-white p-3 sm:p-4 rounded-lg shadow-md" data-id="element-62">
                  <div className="text-2xl sm:text-3xl mb-2" data-id="element-63">🎁</div>
                  <div className="font-semibold text-sm sm:text-base text-gray-800" data-id="element-64">
                    3 Bonos Incluidos
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600" data-id="element-65">
                    Valor adicional gratis
                  </div>
                </div>
                <div className="bg-white p-3 sm:p-4 rounded-lg shadow-md" data-id="element-66">
                  <div className="text-2xl sm:text-3xl mb-2" data-id="element-67">📋</div>
                  <div className="font-semibold text-sm sm:text-base text-gray-800" data-id="element-68">
                    Menús Semanales
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600" data-id="element-69">
                    Todo organizado
                  </div>
                </div>
              </div>
            </div>
            <a href="https://mikioscodigital.com/cart/51606060794137:1?checkout" target="_blank" rel="noopener noreferrer" className="group relative mt-6 sm:mt-8 inline-flex items-center justify-center gap-3 px-8 py-4 sm:px-10 sm:py-5 rounded-full bg-gradient-to-br from-amber-300 via-amber-500 to-amber-600 text-gray-900 font-bold text-lg sm:text-xl tracking-wide shadow-[0_0_20px_rgba(245,158,11,0.5)] hover:shadow-[0_0_40px_rgba(245,158,11,0.8)] hover:scale-105 hover:-translate-y-1 transition-all duration-300 mx-auto w-fit overflow-hidden border-2 border-amber-200/50" data-id="element-70">
              {/* 3D Shine Overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/40 via-white/10 to-transparent opacity-100 pointer-events-none rounded-full" data-id="element-71"></div>

              {/* Animated Glow Pulse */}
              <div className="absolute inset-0 rounded-full bg-amber-400/30 blur-xl animate-pulse" data-id="element-72"></div>

              <ShoppingCartIcon className="relative z-10 w-6 h-6 sm:w-7 sm:h-7 drop-shadow-md" data-id="element-73" />
              <span className="relative z-10 drop-shadow-md uppercase" data-id="element-74">
                QUIERO MI PACK DE 15 MINUTOS AHORA!!!
              </span>
            </a>
            <div className="mt-4 sm:mt-6 bg-gradient-to-br from-orange-50 to-orange-100 p-4 sm:p-6 rounded-xl sm:rounded-2xl border-2 border-orange-200 shadow-lg" data-id="element-75">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 md:gap-8" data-id="element-76">
                <div className="text-center" data-id="element-77">
                  <div className="text-xs sm:text-sm font-semibold text-orange-700 mb-1" data-id="element-78">
                    VALOR TOTAL DE LOS BONOS
                  </div>
                  <div className="text-2xl sm:text-3xl font-bold text-orange-600" data-id="element-79">
                    $250.00 USD GRATIS
                  </div>
                </div>
                <div className="hidden sm:block w-px h-12 bg-orange-300" data-id="element-80"></div>
                <div className="text-center" data-id="element-81">
                  <div className="text-xs sm:text-sm font-semibold text-gray-600 mb-1" data-id="element-82">
                    Precio Normal vs. Hoy
                  </div>
                  <div className="flex items-center gap-2 sm:gap-3" data-id="element-83">
                    <span className="text-xl sm:text-2xl text-gray-500 line-through" data-id="element-84">
                      $250
                    </span>
                    <span className="text-2xl sm:text-3xl font-bold text-orange-600" data-id="element-85">
                      $9.95 USD
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ExtraBonusModal isOpen={isExtraBonusModalOpen} onClose={() => setIsExtraBonusModalOpen(false)} data-id="element-86" />
    </>;
}